<template>
  <div class="box vh-140">
    <div class="box-header">
      <i class="fa fa-th-large"></i>
      <h3 class="box-title">模型列表</h3>
    </div>
    <div class="box-body">
      <el-row class="margin-bottom-10" gutter="20">
        <el-col :span="18">
          <el-button type="primary" size="small" @click="toAdd()" plain><i class="fa fa-plus"></i> 添加模型</el-button>
        </el-col>
      </el-row>
      <el-table class="list-table" :data="modelList" border :stripe="true" style="width: 100%"
                :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
        <template slot="empty">
          <div class="no-data">暂无数据！</div>
        </template>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="模型名称" min-width="150"></el-table-column>
        <el-table-column prop="industryName" label="行业名称" min-width="120"></el-table-column>
        <el-table-column prop="postName" label="岗位" min-width="120"></el-table-column>
        <el-table-column label="类型" width="130">
          <template slot-scope="scope">
            <el-tag type="plain" v-if="scope.row.type==0" size="small">通用模型</el-tag>
            <el-tag type="danger" v-if="scope.row.type==1"  size="small">公司模型</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="scale" label="模型大维度" min-width="300">
          <template slot-scope="scope">
            <el-tag type="" effect="plain" size="small" v-for="tag in scope.row.contents" :key="tag" style="margin-right: 5px;" >
              {{tag}}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="text" @click ="toAdd(scope.row.id)" size="small"><i class="fa fa-edit"></i> 编辑</el-button>
            <el-button type="text" @click.prevent="deleteModel(scope.row.id)" size="small"><i class="fa fa-trash"></i> 删除</el-button>
          </template>
        </el-table-column>
      </el-table>

    <model-save :visible="modelDrawer" :model-id="modelId" @done="handleFinish"></model-save>
    </div>
  </div>
</template>

<script>
import { fetchList,remove } from '@/api/rep/model'
import {mapGetters} from "vuex";
import ModelSave from "./ModelSave";
import {handleConfirm} from "@/utils/confirm";

export default {
  name: 'ev-company',
  components: {ModelSave},
  computed: {
    ...mapGetters(['user', 'company'])
  },
  data: function() {
    return {
      modelList:[],
      names:[],
      model:{},
      modelId:null,
      modelDrawer:false,
      addModelDrawer:false
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      fetchList(this.company.id).then(resp => {
        this.modelList= resp.data.result
        this.modelList.map(x =>{
          x.contents = JSON.parse(x.contents)
          x.contents = x.contents.map(x=>{return x.name})
        })
      })
    },
    toAdd(val){
      this.modelId = val
      this.modelDrawer = true
    },
    handleFinish(flag = false){
      this.modelDrawer = false
      if (flag) {
        this.fetchData()
      }
    },
    deleteModel(id){
      handleConfirm('此操作将删除该维度, 是否继续?').then(() => {
        remove(id).then(resp => {
          this.$message.success(resp.data.message);
          this.fetchData();
        })
      })
    }
  },
}
</script>
